import React from 'react';
import t from 'prop-types';
import { connect } from 'react-redux';
import { getPantalla, getPantallas, getPantallaProps, getCaducado } from './selectors';
import Precarga from './precarga';
import VentanaCaducidadContainer from './ventana-caducidad';

var Ibook = function Ibook(_ref) {
  var pantallas = _ref.pantallas,
      pantallaId = _ref.pantallaId,
      pantallaProps = _ref.pantallaProps,
      caducado = _ref.caducado;

  if (caducado) {
    return React.createElement(VentanaCaducidadContainer, null);
  }

  var Pantalla = pantallas[pantallaId];

  if (Pantalla) {
    return React.createElement(React.Fragment, null, !caducado && React.createElement(Pantalla, pantallaProps), React.createElement(VentanaCaducidadContainer, null));
  }

  return React.createElement(Precarga, null);
};

Ibook.propTypes = process.env.NODE_ENV !== "production" ? {
  pantallas: t.object.isRequired,
  pantallaId: t.string.isRequired,
  pantallaProps: t.object,
  caducado: t.bool.isRequired
} : {};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var pantallas = getPantallas(state);
  var pantallaId = getPantalla(state);
  var pantallaProps = getPantallaProps(state);

  var _getCaducado = getCaducado(state),
      caducado = _getCaducado.caducado;

  return {
    pantallas: pantallas,
    pantallaId: pantallaId,
    pantallaProps: pantallaProps,
    caducado: caducado
  };
};

export default connect(mapStateToProps)(Ibook);